import { useQuery } from '@tanstack/react-query';
import PatientHomeService from '@/services/PatientHomeService';
import { getProgramId } from '@/config/program';
import { PATIENT_HOME_KEYS } from './keys';

// Coordinator preview of the patient's companion home. refetchInterval mirrors
// the spark's 30s silent refresh (60s here — a preview needn't be as aggressive),
// paused in the background, and lives on THIS key only — never attach it to the
// shared useMeasureReadings key (the charts' series), or every other consumer polls.
export function usePatientHome(userid: string | number | null | undefined) {
  return useQuery({
    queryKey: PATIENT_HOME_KEYS.byUser(userid ?? ''),
    queryFn: () => PatientHomeService.fetchPatientHome(userid!, getProgramId()),
    enabled: userid != null && userid !== '',
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
